import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "items", "role"];
import React from 'react';
import NavList from './NavList';

var Nav = function Nav(_ref) {
  var children = _ref.children,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'navigation' : _ref$role,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("nav", _extends({}, unhandledProps, {
    role: role
  }), children != null ? children : /*#__PURE__*/React.createElement(NavList, {
    items: items
  }));
};

export default Nav;